import React from 'react';

import { DEFAULT_ICON_PROPS, IIconProps } from '../constants';

export const BlueWaterIcon = ({ ariaLabel = 'Water icon', ...props }: IIconProps) => {
  const { size, width, height, title, ariaHidden, className } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={size || width}
      height={size || height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ariaLabel}
      aria-hidden={ariaHidden}
      className={`block ${className}`}
      {...props}
    >
      {title && <title>{title}</title>}
      <rect y="0.5" width="32" height="32" rx="16" fill="#E9F8FF" />
      <circle
        cx="16.0191"
        cy="16.5223"
        r="8.97222"
        fill="#006694"
        stroke="#E9F8FF"
        strokeWidth="1.5"
      />
      <mask
        id="mask0_11069_52594"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="7"
        y="8"
        width="18"
        height="17"
      >
        <circle cx="16.0208" cy="16.5223" r="8.33333" fill="#3675B2" />
      </mask>
      <g mask="url(#mask0_11069_52594)">
        <path
          d="M6.29688 18.8835C9.34699 19.3001 11.8524 17.2168 11.8524 17.2168C11.8524 17.2168 13.5885 18.8835 16.0191 18.8835C18.4497 18.8835 19.8385 17.2168 19.8385 17.2168C19.8385 17.2168 23.0725 19.3001 25.7413 18.8835"
          stroke="#E9F8FF"
          strokeWidth="1.8"
        />
      </g>
    </svg>
  );
};
